var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "url(#paint0_linear_468_18058)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6642 44.6996L42.2783 34.3136C42.9953 33.5967 42.9953 32.4346 42.2783 31.7176C41.9194 31.3587 41.4502 31.1797 40.9802 31.1797C40.5102 31.1797 40.0412 31.3587 39.6821 31.7176L37.0853 34.3136L33.1904 38.2086L30.5943 40.8047C29.8774 41.5215 29.8774 42.6846 30.5943 43.4015C30.9533 43.7604 31.4223 43.9394 31.8923 43.9394C32.3623 43.9394 32.8314 43.7604 33.1904 43.4015L43.5763 53.7866C46.086 56.2963 50.1543 56.2963 52.6641 53.7866C55.173 51.2778 55.173 47.2084 52.6642 44.6996Z",
    fill: "#232B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.583 19.9219C50.1041 19.9219 51.3369 21.1556 51.3369 22.6758C51.3369 24.1969 50.1041 25.4297 48.583 25.4297C47.0619 25.4297 45.8291 24.1969 45.8291 22.6758C45.8291 21.1556 47.0619 19.9219 48.583 19.9219Z",
    fill: "#FFE600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0439 42.8711C22.0583 42.8711 22.8799 43.6935 22.8799 44.707C22.8799 45.7213 22.0583 46.543 21.0439 46.543C20.0305 46.543 19.208 45.7213 19.208 44.707C19.208 43.6935 20.0305 42.8711 21.0439 42.8711Z",
    fill: "#FFE600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.173 51.1905L43.5761 53.7866L33.1902 43.4015L35.7871 40.8047L46.173 51.1905Z",
    fill: "#232B3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0672 47.295L48.1202 49.2431L37.7344 38.8571L39.6822 36.9102L50.0672 47.295Z",
    fill: "#232B3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7817 40.8027L37.7284 38.856L48.1127 49.2404L46.1661 51.1871L35.7817 40.8027Z",
    fill: "#313A52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.664 44.6995L50.0671 47.2954L39.6821 36.9105L42.2782 34.3135L52.664 44.6995Z",
    fill: "#313A52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0855 34.3138L33.1906 38.2087L19.5596 24.5778L16.9636 18.0859L23.4546 20.683L37.0855 34.3138Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2783 31.7176C42.9953 32.4346 42.9953 33.5967 42.2783 34.3136L39.6822 36.9107L37.7344 38.8576L35.7873 40.8047L33.1904 43.4015C32.8314 43.7604 32.3623 43.9394 31.8923 43.9394C31.4223 43.9394 30.9533 43.7604 30.5943 43.4015C29.8774 42.6845 29.8774 41.5215 30.5943 40.8047L33.1904 38.2086L37.0853 34.3136L39.6821 31.7176C40.0411 31.3587 40.5102 31.1797 40.9802 31.1797C41.4502 31.1797 41.9194 31.3587 42.2783 31.7176Z",
    fill: "#3DB9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6643 44.6992C55.173 47.208 55.173 51.2774 52.6643 53.7862C50.1545 56.2959 46.0861 56.2959 43.5764 53.7862L46.1734 51.1901L48.1204 49.2432L50.0674 47.2951L52.6643 44.6992Z",
    fill: "#3DB9FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2549 32.7734C51.7482 32.7734 51.3369 33.1847 51.3369 33.6914C51.3369 34.199 51.7482 34.6094 52.2549 34.6094C52.7624 34.6094 53.1729 34.199 53.1729 33.6914C53.1729 33.1847 52.7625 32.7734 52.2549 32.7734Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1572 15.332C41.6505 15.332 41.2393 15.7433 41.2393 16.25C41.2393 16.7576 41.6505 17.168 42.1572 17.168C42.6648 17.168 43.0752 16.7576 43.0752 16.25C43.0752 15.7433 42.6649 15.332 42.1572 15.332Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9775 51.1328C32.4708 51.1328 32.0596 51.544 32.0596 52.0508C32.0596 52.5583 32.4708 52.9688 32.9775 52.9688C33.4852 52.9688 33.8955 52.5583 33.8955 52.0508C33.8955 51.5439 33.4852 51.1328 32.9775 51.1328Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3057 18.0859C28.7989 18.0859 28.3877 18.4972 28.3877 19.0039C28.3877 19.5115 28.7989 19.9219 29.3057 19.9219C29.8133 19.9219 30.2236 19.5115 30.2236 19.0039C30.2236 18.4972 29.8133 18.0859 29.3057 18.0859Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 49.2969C17.7833 49.2969 17.3721 49.708 17.3721 50.2148C17.3721 50.7224 17.7833 51.1328 18.29 51.1328C18.7977 51.1328 19.208 50.7224 19.208 50.2148C19.208 49.7079 18.7977 49.2969 18.29 49.2969Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 32.7734C18.29 32.2667 17.8797 31.8555 17.3721 31.8555C16.8654 31.8555 16.4541 32.2667 16.4541 32.7734C16.4541 33.2811 16.8654 33.6914 17.3721 33.6914C17.8797 33.6914 18.29 33.2811 18.29 32.7734Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_18058",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMaintain);
export default __webpack_public_path__ + "static/media/img_maintain.256034ac715f4daa5ff6842501e9c2b4.svg";
export { ForwardRef as ReactComponent };